import { CustomLicenseField } from "../helpers/CustomLicenseField";
import { useEffect } from "react";

export const LicenseFields = ({ id, fields, indices, readOnly, updateField }) => {

  useEffect(() => {
    fields.forEach((fieldInstance) => { tangibleFields.fields.rerender(`${id}-${fieldInstance.name}`)})
  }, [readOnly])

  return (
    <div className="tgbl-user-accrediting-agencies__list__item__panel__inner__form__license-fields">
      { fields.map(( fieldInstance, index ) => {
        return (
          <div
            key={`${id}-${fieldInstance.name}-${readOnly ? 1 : 0}`}
            className="tgbl-user-accrediting-agencies__list__item__panel__inner__form__license-fields__field"
          >
            {/* LICENSE CODE */}
            { fieldInstance.mask
              ? <CustomLicenseField
                name={`${id}-${fieldInstance.name}`}
                label={fieldInstance.label}
                prefix={fieldInstance.prefix}
                suffix={fieldInstance.suffix}
                mask={fieldInstance.mask}
                value={fieldInstance.value}
                onChange={ licenseValues => updateField(licenseValues, indices[index])}
                readOnly={readOnly}
              />
              : tangibleFields.render({
                ...fieldInstance,
                type: 'text',
                name: `${id}-${fieldInstance.name}`,
                readOnly: readOnly,
                onChange: value => {
                  if ( value === fieldInstance.value || value === fieldInstance.display_value ) return

                  // TField only returns the equivalent of our "display value"
                  updateField({
                    value: value.substring(
                      fieldInstance.prefix ? fieldInstance.prefix.length : 0,
                      value.length - ( fieldInstance.suffix ? fieldInstance.suffix.length : 0 )
                    ),
                    display_value: value
                  }, indices[index])
                }
              })
            }

            {/* RENEWAL DATE */}
            { fieldInstance.renewal_date !== undefined && <div className="tf-context-default">
              <div className="tf-date-picker">
                <label htmlFor={`${id}-${fieldInstance.name}-renewal`} className="tf-label">Next Renewal Date</label>
                <div className="tf-date-field-container">
                  <input
                    type="date"
                    name={`${id}-${fieldInstance.name}-renewal`} id={`${id}-${fieldInstance.name}-renewal`}
                    className="tf-date-field"
                    disabled={readOnly}
                    value={fieldInstance.renewal_date}
                    onChange={e => updateField({ renewal_date: e.target.value }, indices[index])}
                  />
                </div>
              </div>
            </div> }
          </div>
        )
      })}
    </div>
  )
}
